import styles from './Ligne.module.css'
import {
  Slider,
  MenuItem,
  TextField
} from '@mui/material'
import {
  isDesktop
} from 'react-device-detect'
import {
  get_range
} from '../../Functions/Functions'
import {
  minimum,
  maximum
} from '../../Variables/Variables'

const Ligne = ({
  label,
  state,
  target,
  Update
}) => {
  return (
    <div className={styles.ligne}>
      <label>
        {label}
      </label>
      {
        (isDesktop)
          ? <Slider
              step={1}
              value={state[target]}
              min={minimum[target]}
              max={maximum[target]}
              className={styles.slider}
              onChange={(event, value) => Update(value, target)}
              onChangeCommitted={(event, value) => Update(value, target, true)}
            />
          : null
      }
      <TextField
        size="small"
        select={true}
        variant="outlined"
        value={state[target]}
        className={styles.input}
        onChange={(event) => Update(event.target.value, target, true)}
      >
        {
          get_range(minimum[target], maximum[target]).map(item => {
            return (
              <MenuItem
                key={item}
                value={item}
              >
                {item}
              </MenuItem>
            )
          })
        }
      </TextField>
    </div>
  )
}

export default Ligne
